export default {
  active: null,
  lastVisited: null,
};
